// import { Driver, Fleet } from "@/interfaces/Company";

export const transformFleetData = (fleetByCompany: any[]) => {
  return (
    fleetByCompany?.map((item) => ({
      vehicle_question_id: item.vehicle_question_detail?.id || item.vehicle_question_id,
      quantity_owned: item.quantity_owned || 0,
      quantity_contractors: item.quantity_contractors || 0,
      quantity_leasing: item.quantity_leasing || 0,
      quantity_renting: item.quantity_renting || 0,
      quantity_workers: item.quantity_workers || 0,
      diagnosis_counter: item.diagnosis_counter_detail?.id, //! REVISAR PORQUE NO LLEGA EN LA RESPONSE DE LA API
      // quantity_arrended: item.quantity_arrended,
      // quantity_intermediation: item.quantity_intermediation,
      // quantity_third_party: item.quantity_third_party,
      // quantity_employees: item.quantity_employees,
    })) || []
  );
};

export const transformDriverData = (driverByCompanyid: any[]) => {
  return (
    driverByCompanyid?.map((item) => ({
      // diagnosis_counter: item.diagnosis_counter_detail?.id,
      driver_question: item.driver_question_detail?.id,
      quantity: item.quantity,
    })) || []
  );
};
